module.exports = __webpack_public_path__ + "img/mssymbol_19.319d9b9a.svg";